document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.faq-accordion__item');

  items.forEach(function (item) {
    var button = item.querySelector('.faq-accordion__question');
    var answer = item.querySelector('.faq-accordion__answer');

    button.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      // Close all other items (accordion behavior: one open at a time)
      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('.faq-accordion__question').setAttribute('aria-expanded', 'false');
          other.querySelector('.faq-accordion__answer').style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});